module.exports = __webpack_public_path__ + "res/brand_race.a52960e63077d4fc53f1cd9bc1a474b8.webp";